import { Component, ViewChild, viewChild } from '@angular/core';
import { IllustrationComponent } from './illustration/illustration.component';

@Component({
  selector: 'app-size-chart',
  standalone: true,
  imports: [IllustrationComponent],
  templateUrl: './size-chart.component.html',
  styleUrl: './size-chart.component.scss'
})
export class SizeChartComponent {
  diagramSrc = 'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Measuring_Diagram_whole_body.svg?v=1743430525';
  @ViewChild('diagram') diagramDialog: any;

  openDiagram() {
    this.diagramDialog.nativeElement.show();
  }
  closeDiagram() {
    this.diagramDialog.nativeElement.close();
  }
}
